import React, { useEffect, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import { Row } from 'styled/alignment/Row';
import HomeWrapper from './HomeWrapper';
import DashHeaderActions from 'modules/dashboard/_common/DashHeaderActions';
import MainV2 from 'modules/home/MainV2';
import HomeHeader from 'components/commons/HomeHeader';

const HOME_THEME_CLASS = 'home-accent-theme';

export default function Home() {
    const [mobileView, setMobileView] = useState('list');

    // ModalLocation e SearchOverlayResults são compartilhados com as páginas
    // de busca de eventos/estabelecimentos, então a cor não pode ser trocada
    // direto neles — só enquanto a Home estiver montada, via classe no body.
    useEffect(() => {
        document.body.classList.add(HOME_THEME_CLASS);
        return () => document.body.classList.remove(HOME_THEME_CLASS);
    }, []);

    return (
        <HomeWrapper>
            <HomeAccentStyle />
            <HomeHeader mobileView={mobileView} />
            <ContentHeader>
                <DashHeaderActions />
            </ContentHeader>
            <MainV2 mobileView={mobileView} setMobileView={setMobileView} />
        </HomeWrapper>
    );
}

const HomeAccentStyle = createGlobalStyle`
    body.${HOME_THEME_CLASS} {
        --home-accent: ${colors.homeAccent};
        --home-logo-color: ${colors.homeAccent};
        --home-accent-08: ${colors.homeAccent}08;
        --home-accent-12: ${colors.homeAccent}12;
        --home-accent-tint-1: #F3ECFD;
        --home-accent-tint-2: #EADDFB;
        --home-accent-tint-3: #E1CEFA;
        --home-search-bg: transparent;
    }
`;

const ContentHeader = styled(Row)`
    display: none;
    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }
`;
